import React from 'react';

const POSTES = [
  { name: 'Plomberie', key: 'plomberie' },
  { name: 'Peinture', key: 'peinture' },
  { name: 'Électricité', key: 'electricite' },
  { name: 'Froid / Climatisation', key: 'froidClimatisation' },
  { name: 'Autre', key: 'autre' },
];

export default function PosteBarChart({ stats }) {
  const maxCount = Math.max(
    stats.plomberie || 0,
    stats.peinture || 0,
    stats.electricite || 0,
    stats.froidClimatisation || 0,
    stats.autre || 0,
    1
  );
  const step = Math.ceil(maxCount / 7) || 1;
  const maxValue = Math.ceil(maxCount / step) * step;
  const axisSteps = [];
  for (let i = maxValue; i >= 0; i -= step) {
    axisSteps.push(i);
  }

  return (
    <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-6">
      <div className="flex justify-between items-center mb-6 pb-2 border-b-2 border-blue-400">
        <h2 className="text-xl font-semibold text-gray-800">Poste de Technicien Souhaité</h2>
        <span className="text-sm text-gray-600">
          {stats.total} réponses
          {stats.source === 'server' ? ' · API' : ' · local'}
        </span>
      </div>
      <div className="mt-8">
        <div className="flex gap-5 h-60">
          <div className="flex flex-col justify-between pb-5 pr-3">
            {axisSteps.map((value, idx) => (
              <div
                key={idx}
                className="text-xs text-gray-600 text-right"
                style={{ height: `${100 / axisSteps.length}%` }}
              >
                {value}
              </div>
            ))}
          </div>
          <div className="flex-1 flex items-end justify-between gap-2 pb-5 border-b border-gray-300">
            {POSTES.map(({ name, key }) => {
              const count = stats[key] || 0;
              const percentage =
                stats.total > 0 ? ((count / stats.total) * 100).toFixed(1) : 0;
              const barHeight = maxValue > 0 ? (count / maxValue) * 100 : 0;
              return (
                <div key={key} className="flex-1 flex flex-col items-center gap-2 h-full justify-end">
                  <span className="text-xs font-semibold text-gray-700">
                    {count} ({percentage}%)
                  </span>
                  <div
                    className="w-full bg-blue-500 rounded-t"
                    style={{ height: `${barHeight}%`, minHeight: count > 0 ? '4px' : '0' }}
                    title={name}
                  />
                  <span className="text-[10px] text-gray-600 text-center leading-tight">{name}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
